import { rootApi } from '../rootApi';

export const dealerAddressPriceListApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getDealerAddressPriceList: builder.query({
            query: (params) => ({
                url: 'v1/dealeraddresspricelist/getlist',
                method: 'POST',
                body: {
                    dealerId: params?.dealerId,
                    dealerName: params?.dealerName ?? null,
                    dealerAddressName: params?.dealerAddressName ?? null,
                    priceListId: params?.priceListId ?? null,
                    usageType: params?.usageType ?? null,
                    startDate: params?.startDate ?? null,
                    endDate: params?.endDate ?? null,
                    activeOnly: params?.activeOnly ? 1 : 0,
                    pageNumber: params?.pageNumber ?? 1,
                    pageSize: params?.pageSize ?? 10
                }
            }),
            transformResponse: (response) => {
                if (response?.data) {
                    const { totalCount, items } = response.data;
                    console.log('✅ [getDealerAddressPriceList] Fetched:', totalCount, 'records');
                    return { totalCount, items };
                }
                return { totalCount: 0, items: [] };
            },
            providesTags: ['DealerAddressPriceList']
        }),

        getDealerAddressPriceListDropdown: builder.query({
            query: () => ({
                url: 'v1/dealeraddresspricelist/getfordropdown',
                method: 'POST',
                body: {}
            }),
            transformResponse: (response) => response?.data || [],
            providesTags: ['DealerAddressPriceList']
        }),

        getDealerAddressPriceListById: builder.query({
            query: (id) => ({
                url: `v1/dealeraddresspricelist/getbyid`,
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => {
                return response;
            },
            providesTags: ['DealerAddressPriceList']
        }),

        addDealerAddressPriceList: builder.mutation({
            query: (newItem) => ({
                url: 'v1/dealeraddresspricelist/add',
                method: 'POST',
                body: newItem
            }),

            transformResponse: (response) => {
                if (response?.isSuccessful === false) {
                    throw {
                        status: response?.httpStatusCode,
                        data: { message: response?.errorMessage }
                    };
                }
                return response;
            },
            invalidatesTags: ['DealerAddressPriceList']
        }),

        updateDealerAddressPriceList: builder.mutation({
            query: (updatedItem) => ({
                url: 'v1/dealeraddresspricelist/update',
                method: 'POST',
                body: updatedItem
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful === false) {
                    throw {
                        status: response?.httpStatusCode,
                        data: { message: response?.errorMessage }
                    };
                }
                return response;
            },
            invalidatesTags: ['DealerAddressPriceList']
        }),

        deleteDealerAddressPriceList: builder.mutation({
            // Birleşik onay akışı için delete komutuna dealerAddressBrandId (anchor) eklendi.
            // Geriye dönük uyumluluk: hem sayısal id hem { id, dealerAddressBrandId } kabul edilir.
            query: (arg) => {
                const { id, dealerAddressBrandId } = typeof arg === 'object' && arg !== null ? arg : { id: arg };
                return {
                    url: 'v1/dealeraddresspricelist/delete',
                    method: 'DELETE',
                    body: { id, dealerAddressBrandId }
                };
            },
            invalidatesTags: ['DealerAddressPriceList', 'DealerRegistration']
        }),

        getDealerAddressSapPriceList: builder.query({
            query: () => ({
                url: 'v1/dealeraddressordertype/getsaplist',
                method: 'GET'
            }),
            transformResponse: (res) => res.data,
            providesTags: ['DealerAddressOrderType']
        })
    })
});

export const {
    useGetDealerAddressPriceListQuery,
    useGetDealerAddressPriceListByIdQuery,
    useAddDealerAddressPriceListMutation,
    useUpdateDealerAddressPriceListMutation,
    useDeleteDealerAddressPriceListMutation,
    useGetDealerAddressPriceListDropdownQuery,
    useGetDealerAddressSapPriceListQuery
} = dealerAddressPriceListApi;
